import type { AdSdk } from './types';
let loading: Promise<AdSdk> | undefined;

/** Pin the supplied, locally served SDK; never execute a remote manager script in the app. */
export function loadAdSdk(): Promise<AdSdk> {
  if (window.PicPlayerAds) return Promise.resolve(window.PicPlayerAds);
  if (loading) return loading;
  loading = new Promise<AdSdk>((resolve, reject) => {
    const script = document.createElement('script');
    script.src = '/ads/rail.js';
    script.async = true;
    script.dataset.numbernodeSdk = 'true';
    const timer = window.setTimeout(() => fail(), 6000);
    const cleanup = () => { window.clearTimeout(timer); script.onload = null; script.onerror = null; };
    function fail() { cleanup(); script.remove(); loading = undefined; reject(new Error('Local advertising component is unavailable.')); }
    script.onload = () => {
      cleanup();
      if (window.PicPlayerAds) resolve(window.PicPlayerAds);
      else fail();
    };
    script.onerror = fail;
    document.head.append(script);
  });
  return loading;
}
